import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImagesModule } from 'lib/images/images.module';
import { TypographyModule } from 'lib/typography/typography.module.js';
import { ButtonModule } from '../buttons/button.module';
import { CardModule } from '../card/card.module';
import { AppFlexModule } from '../flex';
import { FormInputsModule } from '../form-inputs/form-inputs.module.js';
import { FormModule } from '../form/form.module';
import { ListModule } from '../list/list.module';
import { LoaderModule } from '../loader/loader.module';
import { MessagesModule } from '../messages/messages.module';
import { GenAiChatComponent } from './gen-ai-chat.component.js';

@NgModule({
	declarations: [GenAiChatComponent],
	exports: [GenAiChatComponent],
	imports: [
		CommonModule,
		FormInputsModule,
		TypographyModule,
		FormModule,
		ButtonModule,
		CardModule,
		AppFlexModule,
		LoaderModule,
		ImagesModule,
		MessagesModule,
		ListModule
	],
	providers: []
})
export class GenAiModule {}
